import axios from "axios";

/** True for the 503 the messenger-token endpoint answers when this environment
 *  has no Intercom app or secret: chat is simply off here (NG-3450).
 *
 *  Imports nothing from the app on purpose: the Sentry capture policy reads it,
 *  and the API client imports that policy. */
export function isIntercomNotConfigured(error: unknown): boolean {
  return (
    axios.isAxiosError(error) &&
    error.response?.status === 503 &&
    (error.response.data as { error?: unknown } | undefined)?.error === "intercom_not_configured"
  );
}
